<template>
  <apexchart
    type="line"
    height="350"
    :options="chartOptions"
    :series="series"
  ></apexchart>
</template>

<script>
import Cookie from "@/helper/cookie.js";
import chart_state from "@/store/chart/relawan/data/perkembangan";

import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },

  computed: {
    item: {
      get() {
        return chart_state.state.data;
      },
      set(value) {
        console.log(value);
      },
    },
  },

  watch: {
    async item() {
      this.getData();
    },
  },

  data: () => ({
    session: "",

    series: [
      {
        data: [],
      },
    ],

    chartOptions: {},
  }),

  async mounted() {
    this.session = await JSON.parse(Cookie.dec(Cookie.get("myCookie")));
  },

  methods: {
    getData() {
      let label = this.item.map((row) => row.hari);

      this.chartOptions = {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },

        dataLabels: {
          enabled: false,
        },

        stroke: {
          curve: "straight",
        },

        title: {
          text: "Perkembangan Relawan",
          align: "left",
        },

        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },

        xaxis: {
          categories: label,
        },
      };

      this.series = [
        {
          name: "Jumlah",
          data: this.item.map((row) => row.jumlah),
        },
      ];
    },
  },
};
</script>
